import { useUserData, withUserData } from "@/contexts/UserDataContext";
import { LinkButton } from "../shared/generic";

const GetStartedButton = ({ inverted }) => {
  const { currentUser } = useUserData();

  if (!currentUser) {
    return (
      <LinkButton
        size={{ base: "lg", md: "md" }}
        borderRadius="xl"
        href="/get-started"
        colorScheme={inverted ? undefined : "black"}
        variant="solid"
      >
        Get Started
      </LinkButton>
    );
  } else {
    return (
      <LinkButton
        size={{ base: "lg", md: "md" }}
        borderRadius="xl"
        href="/profile/dashboard"
        colorScheme={inverted ? undefined : "black"}
        variant="solid"
      >
        My Account
      </LinkButton>
    );
  }
};

export default withUserData(GetStartedButton);
